import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { clearAdminSessionAndRedirect } from "../../utils/adminSession";

/** Aborted in-flight requests (pagination, Strict Mode, tab change) — not a real network failure. */
function isRequestAborted(error) {
  if (error == null) return false;
  if (error.code === "ERR_CANCELED") return true;
  if (error.name === "CanceledError" || error.name === "AbortError") return true;
  return false;
}

const url = process.env.REACT_APP_BACKEND_BASE_URL;
const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      let token = localStorage.getItem("token") || Cookies.get("naseebiadmin");

      if (token) {
        token = token.replace(/["',]/g, "");
        config.headers.set("Authorization", `Bearer ${token}`);
      }
    }

    if (config.data instanceof FormData) {
      config.headers.set("Content-Type", "multipart/form-data");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

function isLoginRequest(config) {
  const url = String(config?.url || "").toLowerCase();
  return url.includes("/login") || url.includes("/forgot-password");
}

function isUnauthorized(error) {
  const status = error?.response?.status;
  if (status === 401) return true;
  const message = String(error?.response?.data?.message || "").toLowerCase();
  return message.includes("jwt expired") || message.includes("unauthorized");
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isRequestAborted(error)) {
      return Promise.reject(error);
    }

    if (isUnauthorized(error) && !isLoginRequest(error?.config)) {
      if (error.response?.data && typeof error.response.data === "object") {
        error.response.data.message = "";
      }
      error.adminSessionExpired = true;
      clearAdminSessionAndRedirect();
      return Promise.reject(error);
    }

    if (!error.response) {
      toast.error("Network error. Check your connection and try again.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
